import { useEffect, useState } from "react";

export const useTypewriter = (text, speed = 16, instant = false) => {
  const reduce = instant || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const [n, setN] = useState(reduce ? text.length : 0);
  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => {
      setN((v) => {
        if (v >= text.length) {
          clearInterval(id);
          return v;
        }
        return v + 1;
      });
    }, speed);
    return () => clearInterval(id);
  }, [text, speed, reduce]);
  return [text.slice(0, n), n >= text.length];
};
